import { getUserData } from 'apps/user/actions/user.js';
import { computeNavigationLinks } from 'apps/topNavigation/actions/topNavigation';
import { computePromosNavigationLinks } from 'apps/navigation/actions/navigation';

export function computeUserNavigationLinks() {
  return (dispatch) => {
    dispatch(computeNavigationLinks());
    dispatch(computePromosNavigationLinks());
  };
}

export function refreshApp(onUserDataFetched) {
  return (dispatch, getState, { network }) =>
    getUserData(dispatch, network, onUserDataFetched)
      .then((userData) => {
        if (userData) {
          dispatch(computeUserNavigationLinks());
        }
      });
}
